import * as echarts from 'echarts';
let animationDuration = 2000;

function getColor(color1, color2) {
	return new echarts.graphic.LinearGradient(
		0, 0, 0, 1, // 从上到下渐变
		[{
			offset: 0,
			color: color1
		}, {
			offset: 1,
			color: color2
		}]
	)
}

function setData(data, name = undefined, color = getColor('#00ffea', '#3ac1ff'), barWidth = '5%') {
	return {
		name,
		data,
		type: 'bar',
		barWidth, // 设置柱子宽度（也可以是具体像素：'30'）
		itemStyle: {
			color
		},
		label: {
			color: '#FFF'
		},
	}
}

function setZData(data, color, name = undefined, areaStyle, yAxisIndex) {
	return {
		name,
		type: 'line',
		data,
		smooth: true,
		symbol: 'circle',
		symbolSize: 3,
		showSymbol: true,
		lineStyle: {
			width: 2,
			color
		},
		itemStyle: {
			color
		},
		yAxisIndex,
		areaStyle: areaStyle ? {
			color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					offset: 0,
					color: color
				}, // 顶部：线条颜色
				{
					offset: 1,
					color: 'rgba(0,0,0,0)'
				} // 底部：透明
			])
		} : undefined
	}
}


function getGasList(listNum = 8, fixed = 2, max, jc = 50) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * max + jc).toFixed(fixed)))
	}
	return val
}

function getBFBList(listNum, fixed) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 100).toFixed(fixed)))
	}
	return val
}


// 客户用电
let monthlist = []
let newMonth = new Date().getMonth() + 1;
for (let i = 11; i > -1; i--) {
	let month = newMonth - i;
	if (month < 1) {
		month = 12 + month;
	}
	monthlist.push(`${month}月`);
}

let months = []
for (let i = 1; i < 13; i++) {
	months.push(`${i}月`);
}


export const chart1 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	// legend: {
	// 	// type: 'scroll',
	// 	// orient: 'vertical',
	// 	symbol: 'circle',
	// 	right: 0,
	// 	left: '50%',
	// 	top: '30%',
	// 	itemGap: 20,
	// 	itemWidth: 14,
	// 	itemHeight: 14,
	// 	borderRadius: 10,
	// 	// formatter: function(name,a){
	// 	// 	return name + '\t\t\t'
	// 	// },
	// 	symbolSize: [12, 12], // 设置图例圆形的大小
	// 	textStyle: {
	// 		color: '#3ED4EB'
	// 	}
	// },
	series: [{
		name: '秩序巡逻任务状态',
		type: 'pie',
		radius: ['36%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 0,
				name: '已完成',
				itemStyle: {
					color: '#3dd3eb'
				},
			},
			{
				value: 0,
				name: '未完成',
				itemStyle: {
					color: '#41a3f3'
				},
			},
			{
				value: 0,
				name: '已过期',
				itemStyle: {
					color: '#4f6bed'
				},
			},

			{
				value: 0,
				name: '未派单',
				itemStyle: {
					color: '#1d39c1'
				},
			},
		]
	}]
};


export const chart2 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	series: [{
		name: '环境巡逻任务状态',
		type: 'pie',
		radius: ['36%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 0,
				name: '已完成',
				itemStyle: {
					color: '#3fcda3'
				},
			},
			{
				value: 0,
				name: '未完成',
				itemStyle: {
					color: '#09a18d'
				},
			},
			{
				value: 0,
				name: '已过期',
				itemStyle: {
					color: '#198b5b'
				},
			},

			{
				value: 0,
				name: '未派单',
				itemStyle: {
					color: '#0d654d'
				},
			},
		]
	}]
};



export const chart3 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	series: [{
		name: '客服巡逻任务状态',
		type: 'pie',
		radius: ['36%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 0,
				name: '已完成',
				itemStyle: {
					color: '#e9cf8d'
				},
			},
			{
				value: 0,
				name: '未完成',
				itemStyle: {
					color: '#ff972f'
				},
			},
			{
				value: 0,
				name: '已过期',
				itemStyle: {
					color: '#d57b1f'
				},
			},

			{
				value: 0,
				name: '未派单',
				itemStyle: {
					color: '#855939'
				},
			},
		]
	}]
};



export const chart4 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	series: [{
		name: '工程巡逻任务状态',
		type: 'pie',
		radius: ['36%', '90%'],
		// avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: true
		},
		data: [{
				value: 0,
				name: '已完成',
				itemStyle: {
					color: '#ddafad'
				},
			},
			{
				value: 0,
				name: '未完成',
				itemStyle: {
					color: '#f36565'
				},
			},
			{
				value: 0,
				name: '已过期',
				itemStyle: {
					color: '#d13f39'
				},
			},

			{
				value: 0,
				name: '未派单',
				itemStyle: {
					color: '#833535'
				},
			},
		]
	}]
};

function getBFBListMaxMin(listNum, Max = 100, Min = 60) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Min + Number((Math.random() * (Max - Min)).toFixed(0)))
	}
	return val
}

export const chart5 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: months,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 30,
		left: 40,
		right: 30,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: [{
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	}, {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 0, 0, 34]
		},
		min: 0,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	}],
	series: [
		setData(getGasList(7, 2, 2500), '综合巡逻数量', getColor('#62E4F9', '#0668D4'), '26%'),
		setZData(getBFBListMaxMin(7), '#FF9830', '完成率', false, 1),
		setZData(getBFBListMaxMin(7), '#64ED9E', '及时完成率', false, 1),
	],
};

export const chart6 = {
	xAxis: {
		type: 'category',
		data: ['保安巡逻任务', '保洁巡逻任务', '客服巡逻任务', '工程巡逻任务'],
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item'
	},
	grid: {
		top: 30,
		left: 30,
		right: 30,
		bottom: 20,
	},
	yAxis: {
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [{
		barWidth: '16%',
		data: [{
				value: 30,
				itemStyle: {
					color: getColor('#3ed4eb', '#1d3ac2')
				}
			},
			{
				value: 90,
				itemStyle: {
					color: getColor('#3fcea3', '#0e664e')
				}
			},
			{
				value: 70,
				itemStyle: {
					color: getColor('#e9d08d', '#855a39')
				}
			},
			{
				value: 60,
				itemStyle: {
					color: getColor('#deafad', '#833636')
				}
			},
		],
		type: 'bar'
	}]
};

export const chart7 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: months,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 30,
		left: 30,
		right: 30,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: [{
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	}, {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 0, 0, 34]
		},
		min: 0,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	}],
	series: [
		setData(getGasList(7, 2, 15, 10), '问题跟踪数量', getColor('#62E4F9', '#0668D4'), '26%'),
		setZData(getBFBListMaxMin(7), '#FF9830', '完成率', false, 1),
		setZData(getBFBListMaxMin(7), '#64ED9E', '及时完成率', false, 1),
	],
};